import React, {useCallback} from 'react';
import AsyncSelect from "react-select3/async";
import {HelpBlock} from "react-bootstrap";
import request from 'superagent';
import _ from 'lodash';

const IManageMatterSelect = ({connectionId, onChange, value, meta}) => {
  const getOptions = (inputValue) => {
    if (!inputValue)
      return [];

    return request.get(`/rpc/integrations/connections/${connectionId}/imanage/matters/search`)
      .query({name: inputValue})
      .then(response => response.body.results);
  };

  const loadSuggestedOptions = useCallback(
    _.debounce((inputValue, callback) => {
      getOptions(inputValue).then(options => callback(options));
    }, 500),
    []
  );

  const hasError = meta.error && meta.touched;

  return (
    <div className={hasError ? 'has-error' : undefined}>
      <AsyncSelect
        label={_.get(value, 'name')}
        value={value}
        loadOptions={loadSuggestedOptions}
        loadingMessage={() => 'Searching iManage Matters'}
        noOptionsMessage={() => 'Type to search Matters, only full words will match...'}
        placeholder='Search Matters...'
        getOptionLabel={option => option.name}
        isClearable
        onChange={onChange}
      />
      {hasError && <HelpBlock>{meta.error}</HelpBlock>}
    </div>
  );
};

export default IManageMatterSelect;

export const FinalFormIManageMatterSelector = ({input: {value, onChange}, ...rest}) => {
  return (
    <IManageMatterSelect
      value={value}
      onChange={selectedOption => onChange(selectedOption)}
      {...rest}
    />
  );
}



// WEBPACK FOOTER //
// ./src/CaseFolder/Integrations/iManage/iManageMatterSelector.jsx